import { IAction, ActionType } from "../../classes/actiontype";
import { AppState } from "../../classes/app-state";
import { Dispatch } from "redux";

export function unfavoritePage(): IAction {
    return {
        type: ActionType.IS_UNFAVORITED
    }
}

export function favoritePage(): IAction {
    return {
        type: ActionType.IS_FAVORITED
    }
}

export function invertLocalFavorite() {
    return (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const state = getState();

        if (state.favoritesState.isFavorite)
            dispatch(unfavoritePage());
        else
            dispatch(favoritePage());
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/redux/actions/app-state.ts